import { styled } from '@mui/system';

export const Container = styled('div')`
  padding: 1em;
  position: fixed;
  right: 0px;
  width: 350px;
  height: 100vh;
  border: 1px solid lightgrey;
  overflow-y: auto;
  max-height: 95vh;
`;

type NotificationStatusProps = {
  $type?: boolean;
};

export const NotificationStatus = styled('div', {
  shouldForwardProp: (prop: string) => prop !== '$type',
}) <NotificationStatusProps>`
  width: 100%;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  color: ${(props: NotificationStatusProps) => (props.$type ? '#3284FB' : '#B8860B')};
  display: flex;
  justify-content: space-between;
`;

export const From = styled('div')`
  display: inline-block;
  span {
    color: grey;
  }
  img {
    padding: 0 2em;
  }
`;

export const NotificationName = styled('div')`
  width: 100%;
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  line-height: 23px;
  color: #000000;
  margin-top: 8px;
`;

export const NotificationDesc = styled('div')`
  width: 100%;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
  color: #5c5c5c;
  padding: 0;
  margin-top: 8px;
  padding-bottom: 16px;
`;

export const Notification = styled('div')`
  width: 100%;
  text-align: left;
  margin-bottom: 1em;
  padding: 8px 24px;
`;

export const Divider = styled('div')`
  margin: 16px 0px;
  border-bottom: 1px solid #e5e5e5;
`;

export const Close = styled('button')`
  border: none;
  background-color: transparent;
  color: grey;
  cursor: pointer;
  img {
    width: 8px;
    height: 8px;
    display: block;
    float: right;
  }
`;
